import {api} from './api';

const analyticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    sendAnalyticsEvent: builder.mutation<
      unknown,
      {
        eventName: string;
        eventData: {
          campaign: string;
          domain: string;
          page: string;
          referrer: string;
          screenHeight: number;
          screenWidth: number;
          source: string;
          width: number;
        };
      }
    >({
      query: (arg) => ({
        url: '/analytics',
        method: 'POST',
        body: arg,
      }),
    }),
  }),
});

export const {useSendAnalyticsEventMutation} = analyticsApi;
